export const SET_LOADING = 'src/store/calendar/SET_LOADING'
export const SET_SAVE_LOADING = 'src/store/calendar/SET_SAVE_LOADING'
export const SET_CALENDAR = 'src/store/calendar/SET_CALENDAR'
export const SET_MATCHES = 'src/store/calendar/SET_MATCHES'
export const SET_MATCH = 'src/store/calendar/SET_MATCH'
export const SET_MATCHES_RESPONSE = 'src/store/calendar/SET_MATCHES_RESPONSE'
export const SET_COLOR_RESPONSE = 'src/store/calendar/SET_COLOR_RESPONSE'
